/* KitchenBuildr collection filters (kb-facets).
   Instant AJAX filtering with URL history, live result counts, a mobile drawer,
   per-group search and "show all", and state kept between updates. */
(function () {
  if (window.KBFacets) return;

  var cache = {};
  var controller = null;
  var checkTimer = null;
  var priceTimer = null;
  var lastOpener = null;
  var desktopMq = window.matchMedia('(min-width: 990px)');
  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function qs(sel, root) { return (root || document).querySelector(sel); }
  function qsa(sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); }
  function root() { return qs('[data-kbf-root]'); }
  function panel() { return qs('[data-kbf-panel]'); }

  /* ---------------- Params ---------------- */
  function currentParams() {
    var params;
    var form = qs('[data-kbf-form]');
    if (form) {
      params = new URLSearchParams();
      new FormData(form).forEach(function (value, key) {
        if (String(value).trim() !== '') params.append(key, value);
      });
    } else {
      // No sidebar form on the page: keep whatever filters are in the URL
      // (pills, tiles and chips write there), so changing the sort doesn't clear them.
      params = new URLSearchParams(window.location.search);
      params.delete('page');
      params.delete('section_id');
    }
    var sort = qs('[data-kbf-sort]');
    if (sort && sort.value) params.set('sort_by', sort.value);
    return params.toString();
  }

  function cleanParams(search) {
    var params = new URLSearchParams(search);
    params.delete('page');
    params.delete('section_id');
    var out = new URLSearchParams();
    params.forEach(function (v, k) { if (String(v).trim() !== '') out.append(k, v); });
    return out.toString();
  }

  /* ---------------- Rendering ---------------- */
  function setLoading(on) {
    var r = root();
    if (r) r.classList.toggle('is-filtering', on);
    var collection = qs('#ProductGridContainer .collection');
    if (collection) collection.classList.toggle('loading', on);
    var apply = qs('.kbf__apply');
    if (apply) apply.classList.toggle('is-loading', on);
  }

  function captureState() {
    var state = { open: {}, expanded: {}, search: {}, focus: null, scroll: 0 };
    qsa('[data-kbf-group]').forEach(function (g) {
      state.open[g.id] = g.open;
      if (g.classList.contains('is-expanded')) state.expanded[g.id] = true;
      var s = qs('[data-kbf-group-search]', g);
      if (s && s.value) state.search[g.id] = s.value;
    });
    var active = document.activeElement;
    if (active && active.id && panel() && panel().contains(active)) state.focus = active.id;
    var body = qs('[data-kbf-scroll]');
    if (body) state.scroll = body.scrollTop;
    return state;
  }

  function restoreState(state) {
    qsa('[data-kbf-group]').forEach(function (g) {
      if (Object.prototype.hasOwnProperty.call(state.open, g.id)) g.open = state.open[g.id];
      if (state.expanded[g.id]) setExpanded(g, true);
      if (state.search[g.id]) {
        var s = qs('[data-kbf-group-search]', g);
        if (s) { s.value = state.search[g.id]; filterGroup(g); }
      }
    });
    if (state.focus) {
      var el = document.getElementById(state.focus);
      if (el && !el.disabled) el.focus({ preventScroll: true });
    }
    var body = qs('[data-kbf-scroll]');
    if (body) body.scrollTop = state.scroll;
  }

  function apply(html) {
    var doc = new DOMParser().parseFromString(html, 'text/html');

    var grid = document.getElementById('ProductGridContainer');
    var newGrid = doc.getElementById('ProductGridContainer');
    if (grid && newGrid) grid.innerHTML = newGrid.innerHTML;

    var state = captureState();
    qsa('[data-kbf-region]').forEach(function (region) {
      var next = qs('[data-kbf-region="' + region.dataset.kbfRegion + '"]', doc);
      if (next) region.innerHTML = next.innerHTML;
    });
    restoreState(state);
    syncMobileButton();

    return doc;
  }

  function render(params, opts) {
    opts = opts || {};
    var r = root();
    if (!r) return;
    params = cleanParams(params || '');
    var sectionId = r.dataset.sectionId;
    var url = window.location.pathname + '?' + (params ? params + '&' : '') + 'section_id=' + encodeURIComponent(sectionId);
    var pageUrl = window.location.pathname + (params ? '?' + params : '');

    if (opts.push !== false && pageUrl !== window.location.pathname + window.location.search) {
      window.history.pushState({ kbf: params }, '', pageUrl);
    }

    if (controller) controller.abort();
    controller = window.AbortController ? new AbortController() : null;
    setLoading(true);
    var analytics = startAnalytics(params);

    var request = cache[url]
      ? Promise.resolve(cache[url])
      : fetch(url, controller ? { signal: controller.signal } : {}).then(function (res) {
          if (!res.ok) throw new Error('Filter request failed (' + res.status + ')');
          return res.text();
        });

    request
      .then(function (html) {
        cache[url] = html;
        apply(html);
        setLoading(false);
        announce();
        if (analytics) analytics.resolve();
        if (!isDrawerOpen()) scrollToResults();
        document.dispatchEvent(new CustomEvent('kb:collection:updated', { detail: { params: params } }));
      })
      .catch(function (err) {
        if (err && err.name === 'AbortError') return;
        if (analytics) analytics.reject(err);
        window.location.href = pageUrl; // fall back to a normal page load
      });
  }

  function scrollToResults() {
    var results = document.getElementById('ProductGridContainer');
    if (!results || results.getBoundingClientRect().top >= 0) return;
    results.scrollIntoView({ behavior: reduceMotion ? 'auto' : 'smooth', block: 'start' });
  }

  function announce() {
    var live = qs('[data-kbf-live]');
    var count = qs('[data-kbf-result-count]');
    if (live && count) {
      live.textContent = '';
      setTimeout(function () { live.textContent = count.textContent.trim(); }, 60);
    }
  }

  // Shopify standard analytics events, when the theme provides them
  function startAnalytics(params) {
    try {
      var SE = window.StandardEvents || {};
      if (!SE.CollectionUpdateEvent) return null;
      var r = root();
      var deferred = SE.CollectionUpdateEvent.createPromise();
      var search = new URLSearchParams(params);
      r.dispatchEvent(new SE.CollectionUpdateEvent({
        collection: { id: r.dataset.collectionId || null, handle: r.dataset.collectionHandle || '', productsCount: Number(r.dataset.productsCount) || 0 },
        productFilters: SE.CollectionUpdateEvent.parseProductFilters(search),
        sortKey: SE.CollectionUpdateEvent.getSortKey(search),
        promise: deferred.promise
      }));
      return {
        resolve: function () {
          var el = qs('[data-kbf-result-count]');
          deferred.resolve({ productsCount: el ? Number(el.dataset.count) || 0 : 0 });
        },
        reject: deferred.reject
      };
    } catch (e) { return null; }
  }

  /* ---------------- Group helpers ---------------- */
  function setExpanded(group, expanded) {
    group.classList.toggle('is-expanded', expanded);
    var btn = qs('[data-kbf-more]', group);
    if (btn) btn.textContent = expanded ? btn.dataset.less : btn.dataset.more;
  }

  function filterGroup(group) {
    var input = qs('[data-kbf-group-search]', group);
    var q = input ? input.value.trim().toLowerCase() : '';
    var shown = 0;
    qsa('[data-kbf-option]', group).forEach(function (opt) {
      var match = !q || (opt.dataset.label || '').indexOf(q) !== -1;
      opt.hidden = !match;
      if (match) shown++;
    });
    group.classList.toggle('is-searching', !!q);
    var none = qs('[data-kbf-none]', group);
    if (none) none.hidden = shown > 0;
  }

  /* ---------------- Drawer (mobile) ---------------- */
  function isDrawerOpen() { var r = root(); return !!(r && r.classList.contains('kbf-open')); }

  function openDrawer(opener) {
    var r = root();
    if (!r || desktopMq.matches) return;
    lastOpener = opener || document.activeElement;
    r.classList.add('kbf-open');
    var overlay = qs('.kbf-overlay');
    if (overlay) overlay.hidden = false;
    document.documentElement.classList.add('kbf-lock');
    qsa('[data-kbf-open]').forEach(function (b) { b.setAttribute('aria-expanded', 'true'); });
    var p = panel();
    if (p) setTimeout(function () { p.focus({ preventScroll: true }); }, 60);
  }

  function closeDrawer() {
    var r = root();
    if (!r || !r.classList.contains('kbf-open')) return;
    r.classList.remove('kbf-open');
    var overlay = qs('.kbf-overlay');
    if (overlay) overlay.hidden = true;
    document.documentElement.classList.remove('kbf-lock');
    qsa('[data-kbf-open]').forEach(function (b) { b.setAttribute('aria-expanded', 'false'); });
    if (lastOpener && document.contains(lastOpener)) lastOpener.focus({ preventScroll: true });
    scrollToResults();
  }

  function syncMobileButton() {
    // The mobile "Filter" button lives in the re-rendered results area; nothing to copy.
    qsa('[data-kbf-open]').forEach(function (b) { b.setAttribute('aria-expanded', isDrawerOpen() ? 'true' : 'false'); });
  }

  /* ---------------- Events ---------------- */
  document.addEventListener('change', function (e) {
    var t = e.target;
    if (t.matches('[data-kbf-form] input[type="checkbox"]')) {
      clearTimeout(checkTimer);
      checkTimer = setTimeout(function () { render(currentParams()); }, 220);
      return;
    }
    if (t.matches('[data-kbf-sort]')) { render(currentParams()); return; }
    if (t.matches('[data-kbf-price]')) { clearTimeout(priceTimer); schedulePrice(0); }
  });

  function schedulePrice(delay) {
    clearTimeout(priceTimer);
    priceTimer = setTimeout(function () {
      var min = qs('[data-kbf-price="min"]');
      var max = qs('[data-kbf-price="max"]');
      var hint = qs('[data-kbf-price-hint]');
      if (min && max && min.value && max.value && Number(min.value) > Number(max.value)) {
        if (hint) { hint.textContent = 'Min price must be lower than max price'; hint.classList.add('is-error'); }
        return;
      }
      render(currentParams());
    }, delay);
  }

  document.addEventListener('input', function (e) {
    var t = e.target;
    if (t.matches('[data-kbf-price]')) { schedulePrice(800); return; }
    if (t.matches('[data-kbf-group-search]')) { filterGroup(t.closest('[data-kbf-group]')); }
  });

  document.addEventListener('submit', function (e) {
    if (!e.target.matches('[data-kbf-form]')) return;
    e.preventDefault();
    render(currentParams());
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && isDrawerOpen()) { e.preventDefault(); closeDrawer(); return; }
    // Enter in a group search should not submit the filters
    if (e.key === 'Enter' && e.target.matches('[data-kbf-group-search]')) e.preventDefault();
  });

  document.addEventListener('click', function (e) {
    var t = e.target;
    var link = t.closest('a[data-kbf-link]');
    if (link) {
      e.preventDefault();
      var url = new URL(link.href, window.location.href);
      render(url.search.slice(1));
      return;
    }
    var opener = t.closest('[data-kbf-open]');
    if (opener) { e.preventDefault(); openDrawer(opener); return; }
    if (t.closest('[data-kbf-close]')) { e.preventDefault(); closeDrawer(); return; }
    var more = t.closest('[data-kbf-more]');
    if (more) {
      var group = more.closest('[data-kbf-group]');
      setExpanded(group, !group.classList.contains('is-expanded'));
    }
  });

  window.addEventListener('popstate', function () {
    if (!root()) return;
    render(window.location.search.slice(1), { push: false });
  });

  var onMq = function (e) { if (e.matches) closeDrawer(); };
  if (desktopMq.addEventListener) desktopMq.addEventListener('change', onMq);
  else if (desktopMq.addListener) desktopMq.addListener(onMq);

  window.KBFacets = { render: render, open: openDrawer, close: closeDrawer };
})();